import React from 'react';

import Heading from '@atlaskit/heading';
import CheckCircle from '@atlaskit/icon/glyph/check-circle';
import { Box, Stack, Inline } from '@atlaskit/primitives';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import { Commit as CommitType } from 'src/components/types';
import { useIntl } from 'src/hooks/intl';

import { messages } from '../../../gpg-keys.i18n';

import { GpgKeysVerifiedCardContent } from './verified-card-content';
import { Content, IconBackground, Card } from './verified-card.style';

export type GpgKeysVerifiedCardProps = {
  commit: CommitType;
};

export const GpgKeysVerifiedCard = ({
  commit,
}: GpgKeysVerifiedCardProps): JSX.Element | null => {
  const { formatMessage } = useIntl();

  return (
    <Inline xcss={Card}>
      <Box xcss={IconBackground}>
        <CheckCircle
          size="xlarge"
          label={formatMessage(messages.verifiedLabel)}
          primaryColor={token('color.icon.success', colors.G300)}
        />
      </Box>
      <Stack xcss={Content}>
        <Heading size="medium" as="h3">
          {formatMessage(messages.verifiedTitle)}
        </Heading>
        <GpgKeysVerifiedCardContent commit={commit} />
      </Stack>
    </Inline>
  );
};
